/** Mirrors src/domain/residuals/governingPolicies.ts in the API repo. */
export interface GoverningPolicy {
  key: string;
  label: string;
  territory: string;
  performerRate: number;
  writerRate: number;
}

export const GOVERNING_POLICIES: GoverningPolicy[] = [
  {
    key: 'UK_PAC_WGGB',
    label: 'United Kingdom (PAC / WGGB)',
    territory: 'UK',
    performerRate: 17,
    writerRate: 5.6,
  },
];

export function findGoverningPolicy(key: string | null | undefined): GoverningPolicy | undefined {
  return GOVERNING_POLICIES.find((policy) => policy.key === key);
}
